import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Spinner } from './components/ui/spinner';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Drivers from './components/Drivers';
import Districts from './components/Districts';
import Orders from './components/Orders';
import Deliveries from './components/Deliveries';
import DeerReport from './components/DeerReport';
import Transfers from './components/Transfers';
import Locations from './components/Locations';
import Layout from './components/Layout';
import Privacy from './components/Privacy';
import { AuthProvider, useAuth } from './context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spinner />
      </div>
    );
  }
  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  // Нийтийн хуудас: AuthProvider-ийн /auth/me ба 401 → /login redirect-д орохгүй.
  if (window.location.pathname.replace(/\/+$/, '') === '/privacy') return <Privacy />;
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="drivers" element={<Drivers />} />
            <Route path="districts" element={<Districts />} />
            <Route path="orders" element={<Orders />} />
            <Route path="deliveries" element={<Deliveries />} />
            <Route path="transfers" element={<Transfers />} />
            <Route path="deer-report" element={<DeerReport />} />
            <Route path="locations" element={<Locations />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
